import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import NumberField from "../../components/NumberField";
import RadioField from "../../components/RadioField";
import Box from "../../components/Box";
import { StyledButton, ResetButton } from "../../components/Button";
import {
  StyledLabel,
  StyledFormLabel,
  PercentageSymbol,
  StyledButtonsWrapper,
  StyledDisclaimersWrapper
} from "../App/styles";
import messages from "./messages";
import LinksList from "./linksList";

const ForeCast = ({ values, errors, setValues, setFieldValue }) => {
  const [disableCalculation, setDisableCalculation] = useState(true);

  useEffect(() => {
    setDisableCalculation(
      !!errors.annualSpread ||
        !!errors.participationRate ||
        !!errors.marketForecast
    );
  }, [errors]);

  const handleCalculations = () => {
    const yieldField = values.exclude === "no" ? 0 : 0.02;
    const annualSpread = values.annualSpread / 100;
    const marketForecast = values.marketForecast / 100;
    const participationRate = values.participationRate / 100;

    const div = marketForecast - yieldField;
    const par = div.toFixed(6) * participationRate;
    const spread = par.toFixed(6) - annualSpread;
    const result = Math.max(0, spread.toFixed(6) * 100);
    setFieldValue("resultForecast", result);
    if (values.resultForecast === "") {
      document.getElementById("ResultBox").scrollIntoView(true);
    }
  };

  const handleReset = () => {
    setValues({
      ...values,
      marketForecast: 6.0,
      participationRate: 60,
      annualSpread: 2,
      exclude: "yes",
      resultForecast: ""
    });
  };

  const PercentageSymbolWrapper = (
    <PercentageSymbol>
      <FormattedHTMLMessage {...messages.percentageSymbol} />
    </PercentageSymbol>
  );

  return (
    <React.Fragment>
      <StyledLabel>
        <FormattedMessage {...messages.title} />
      </StyledLabel>
      <Grid container spacing={1} alignItems="center" justify="center">
        <Grid item xs={8} sm={9}>
          <StyledFormLabel>
            <FormattedHTMLMessage {...messages.marketForecast} />
          </StyledFormLabel>
        </Grid>
        <Grid item xs={3} sm={2}>
          {" "}
          <NumberField name="marketForecast" label="" decimalscale={2} />
          {PercentageSymbolWrapper}
        </Grid>
        <Grid item xs={8} sm={9}>
          <StyledFormLabel>
            <FormattedHTMLMessage {...messages.participationRate} />
          </StyledFormLabel>
        </Grid>
        <Grid item xs={3} sm={2}>
          {" "}
          <NumberField name="participationRate" label="" />
          {PercentageSymbolWrapper}
        </Grid>
        <Grid item xs={8} sm={9}>
          <StyledFormLabel>
            <FormattedHTMLMessage {...messages.annualSpread} />
          </StyledFormLabel>
        </Grid>
        <Grid item xs={3} sm={2}>
          {" "}
          <NumberField name="annualSpread" label="" decimalscale={1} />
          {PercentageSymbolWrapper}
        </Grid>
        <Grid item xs={8} sm={9}>
          <StyledFormLabel>
            <FormattedHTMLMessage {...messages.excludeDividend} />
          </StyledFormLabel>
        </Grid>
        <Grid item xs={3} sm={2}>
          {" "}
          <RadioField
            name="exclude"
            options={[
              { label: "YES", value: "yes" },
              { label: "NO", value: "no" }
            ]}
            label={""}
          />
        </Grid>
      </Grid>
      <StyledButtonsWrapper
        container
        spacing={1}
        alignItems="center"
        justify="center"
      >
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <StyledButton
            variant="contained"
            color="primary"
            type="button"
            onClick={handleCalculations}
            disabled={disableCalculation}
          >
            <FormattedMessage {...messages.calculate} />
          </StyledButton>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={3}>
          <ResetButton
            variant="contained"
            color="primary"
            type="button"
            onClick={handleReset}
          >
            <FormattedMessage {...messages.reset} />
          </ResetButton>
        </Grid>
      </StyledButtonsWrapper>
      <Grid container spacing={1} alignItems="center" justify="center">
        <Grid item xs={12}>
          <div id="ResultBox">
            {values.resultForecast !== "" && (
              <Box
                number={values.resultForecast}
                styledTitle={
                  <FormattedHTMLMessage {...messages.expectedProductReturn} />
                }
                className="dynamic-box"
              />
            )}
          </div>
        </Grid>
      </Grid>
      <StyledDisclaimersWrapper container spacing={1} justify="center">
        <Grid item xs={12}>
          <p>
            <FormattedHTMLMessage {...messages.disclaimerOne} />
          </p>
          <p>
            <FormattedHTMLMessage {...messages.disclaimerTwo} />
          </p>
          {values.resultForecast !== "" && (
            <p>
              <FormattedHTMLMessage {...messages.disclaimerThree} />
            </p>
          )}
        </Grid>
        <Grid item xs={12}>
          <label>
            <FormattedHTMLMessage {...messages.disclaimerLabel} />
          </label>
        </Grid>
        <LinksList />
      </StyledDisclaimersWrapper>
    </React.Fragment>
  );
};
export default ForeCast;
